module.exports = __webpack_public_path__ + "static/media/bcrab.7ae3c071.jpg";